import React from 'react'
import './PromoSection.scss'

const koenigImg = require('$assets/images/meinspiel/koenig.jpg')
const dameImg = require('$assets/images/meinspiel/dame.jpg')
const fotoKoenigImg = require('$assets/images/meinspiel/foto-koenig.jpg')
const fotoDameImg = require('$assets/images/meinspiel/foto-dame.jpg')

/**
 * Promotional section for the meinspiel.ch partner shop
 * (personalised Jasskarten / playing cards).
 */
const PromoSection = () => {
  return (
    <section className="vogeli-promo-section">
      <div className="vogeli-promo-wrap">
        <div className="vogeli-promo-block">
          <div className="vogeli-promo-text">
            <h2>Der König trägt<br />dieses Jahr <em>Ihr Gesicht</em></h2>
            <p>
              Bei <strong>meinspiel.ch</strong> bekommen König, Dame und Bauer per KI die Gesichter
              von Familie, Freunden oder dem Team. Ein Jasskartenspiel, das es nur einmal gibt –
              das Weihnachtsgeschenk mit Wiedererkennungswert.
            </p>
            <a className="vogeli-promo-btn" href="https://meinspiel.ch" target="_blank" rel="noopener noreferrer">
              Auf meinspiel.ch personalisieren
            </a>
          </div>
          <div className="vogeli-promo-visual">
            <div className="jass-stage">
              <div className="jass-card jass-koenig">
                <img src={koenigImg} alt="Personalisierte Königskarte" />
              </div>
              <div className="jass-card jass-dame">
                <img src={dameImg} alt="Personalisierte Damenkarte" />
              </div>
              <div className="jass-photo jass-photo-koenig">
                <img src={fotoKoenigImg} alt="Ihr Foto" />
                <span>Ihr Foto</span>
              </div>
              <div className="jass-photo jass-photo-dame">
                <img src={fotoDameImg} alt="Ihr Foto" />
                <span>Ihr Foto</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PromoSection
